import {
  Paper,
  TypographyElement,
  Skeleton
} from 'UI'
import { createUseStyles } from 'react-jss'
import style from './style'
import Text from './text.json'
import Tag from 'components/Catalog/Tag'
import { TopicPath } from 'navigation/Routes'

const useStyle = createUseStyles(style)

const numberOfTagsToShow = 2

export default ({ Tags = [], handleTagClick, margin, marginTag, loading }) => {
  const { paperClass, tagNameWrapper } = useStyle({ margin })
  const tagsToShow = loading ? [...Array(numberOfTagsToShow).fill({ loading })] : Tags
  return (
    Tags && Tags.length
      ? (
        <Paper className={paperClass}>
          {
            loading
              ? <Skeleton lines={1} width='60%' height={29} gap={12} margin='0 0 16px 0' />
              : (
                <TypographyElement
                  variant='heading5'
                  spacing='0 0 16px 0'
                  Component='h3'
                >
                  {Text.title}
                </TypographyElement>
                )
          }
          <div className={tagNameWrapper}>
            {
              tagsToShow.map((tag, key) => {
                const slug = tag.loading ? '' : tag.Slug ?? tag.Name.trim()
                return tag.loading
                  ? <Tag loading key={`tag-course-${key}-${loading}`} />
                  : tag.Name.length
                    ? <Tag
                        key={`tag-course-${key}`}
                        path={`${TopicPath}/${encodeURIComponent(slug)}`}
                        handleTagClick={() => handleTagClick(`${TopicPath}/${encodeURIComponent(slug)}`)}
                        Name={tag.Name}
                        margin={marginTag}
                      />
                    : null
              }
              )
            }
          </div>
        </Paper>
        )
      : null
  )
}
